import styled from 'styled-components';
import {media} from '../../styles/components/media-queries';

export const Title = styled.h4`
  font-size: 2rem;
  margin: 0 0 ${props => props.theme.margin};
  text-align: center;
`;

export const Thankyou = styled.div`
  font-size: 2rem;
  text-align: center;
  margin-bottom: ${props => props.theme.margin};
`;

export const Form = styled.div`
  font-size: 2rem;
  text-align: left;
  ${media.small`
    margin-bottom: ${props => props.theme.margin};
  `};
`;

export const Textarea = styled.textarea`
  display: block;
  margin: 0;
  padding: 0.4rem 0.8rem;
  border: 0.1rem solid ${props => props.theme.checkoutPage.inputTextBorderColor};
  background: ${props => props.theme.checkoutPage.inputTextBackground};
  box-shadow: inset 0 0.1rem 0.2rem ${props => props.theme.checkoutPage.inputTextShadowColor};
  color: ${props => props.theme.checkoutPage.inputTextColor};
  font-size: 1.8rem;
  font-weight: normal;
  line-height: 3.6rem;
  box-sizing: border-box;
  width: 100%;
`;

export const CallRestaurant = styled.div`
  margin: ${props => props.theme.margin};
  font-size: 2rem;
  font-weight: bold;
  text-align: center;
`;

export const CallRestaurantWrapper = styled.div`
  margin-bottom: ${props => props.theme.margin};
`;



// WEBPACK FOOTER //
// ./components/CheckoutErrorReportModal/CheckoutErrorReportModal.style.js